import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SystemProvider } from './utils/context';
import { BrowserRouter } from 'react-router-dom';
import AxiosComponent from './utils/axios';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <SystemProvider>
      <AxiosComponent/>
      <BrowserRouter >
        <App />
      </BrowserRouter>
    </SystemProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
